export enum InstallLocation {
  BACKYARD = "BACKYARD",
  FRONTYARD = "FRONTYARD",
  LEFTYARD = "LEFTYARD",
  RIGHTYARD = "RIGHTYARD",
}
